module.exports = __webpack_public_path__ + "static/img/11.fd7f593.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/8/1/zh/11.png
// module id = so9s
// module chunks = 0